import {UserMetricInstance} from "../../user/Metric/UserMetricInstance";
import {FileLoadingWorkflowEnum} from "@aiknow-srl/aik-ngx-3dviewer";
import {FileStorageDTO} from "../../storage/FileStorageDTO";

export class ThreeDimModel {
  fileName!: string;
  file: FileStorageDTO;
  metricsMap: Object | Map<number, UserMetricInstance[]>;
  measurePanelMetrics: UserMetricInstance[];
  loadingWorkflowStatus: FileLoadingWorkflowEnum = FileLoadingWorkflowEnum.INIT;

  constructor() {
    this.metricsMap = {};
    this.measurePanelMetrics = [];
    this.file = new FileStorageDTO();
  }
}
